import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchHomePageUI(params) {
  return authPost(`${baseUrl}/MemberPc1/PcHomePageUI`, params);
}
